import React from 'react';
import SecuritySettings from '../components/Settings/SecuritySettings';
import SlackIntegrationSettings from '../components/Settings/SlackIntegrationSettings';
import { Settings as SettingsIcon } from 'lucide-react';

const Settings = () => {
  return (
    <div className="min-h-screen bg-surface-50 dark:bg-surface-950 transition-colors duration-200 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {/* Header */}
        <div className="mb-12">
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-brand-500/10 rounded-2xl">
              <SettingsIcon className="h-8 w-8 text-brand-600 dark:text-brand-400" />
            </div>
            <div>
              <h1 className="text-4xl font-bold text-surface-900 dark:text-white tracking-tight">
                Settings
              </h1>
              <p className="text-sm font-medium text-surface-500 tracking-tight mt-1">
                Manage your enterprise infrastructure and security credentials
              </p>
            </div>
          </div>
        </div>

        {/* Dynamic Sections */}
        <div className="space-y-8 animate-fade-in">
          <SecuritySettings />
          <SlackIntegrationSettings />
        </div>
      </div>
    </div>
  );
};

export default Settings;
